export default {"src":"/_next/static/media/discount_40.3b59a5c1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};